import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MaterialModule } from 'src/app/Shared/material.module';

import { FooterComponent } from 'src/app/layout/components/footer/footer.component';

@NgModule({
  declarations: [FooterComponent],
  imports: [RouterModule, MatButtonModule, MatIconModule, MatToolbarModule, MaterialModule],
  exports: [FooterComponent],
})
export class FooterModule {}
